(function () {
  // Add-to-cart event: hook into Shopify's pubsub if available, fallback to form submit
  function pushAddToCart(item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: item.currency || 'GBP',
        value: (item.price || 0) * (item.quantity || 1),
        items: [{
          item_id: item.variant_id || item.product_id,
          item_name: item.product_title || item.title,
          item_variant: item.variant_title,
          item_brand: item.vendor,
          price: item.price,
          quantity: item.quantity || 1,
        }],
      },
    });
  }

  function pushRemoveFromCart(item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: item.currency || 'GBP',
        value: (item.price || 0) * (item.quantity || 1),
        items: [{
          item_id: item.variant_id || item.product_id,
          item_name: item.product_title || item.title,
          price: item.price,
          quantity: item.quantity || 1,
        }],
      },
    });
  }

  // Intercept add-to-cart fetches
  const originalFetch = window.fetch;
  window.fetch = function (url, opts) {
    return originalFetch.apply(this, arguments).then(function (response) {
      try {
        const urlStr = typeof url === 'string' ? url : url.url || '';
        if (urlStr.includes('/cart/add')) {
          response.clone().json().then(function (data) {
            const items = data.items || [data];
            items.forEach(function (item) {
              if (item && item.product_id) {
                pushAddToCart({
                  variant_id: item.variant_id || item.id,
                  product_id: item.product_id,
                  product_title: item.product_title || item.title,
                  variant_title: item.variant_title,
                  vendor: item.vendor,
                  price: (item.price || 0) / 100,
                  quantity: item.quantity,
                  currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP',
                });
              }
            });
          }).catch(function () {});
        }
        if (urlStr.includes('/cart/change') || urlStr.includes('/cart/update')) {
          // Could detect removals here if needed
        }
      } catch (e) {}
      return response;
    });
  };

  // Begin checkout — listen for checkout button clicks
  document.addEventListener('click', function (e) {
    const target = e.target.closest('[name="checkout"], [href*="/checkout"]');
    if (!target) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            currency: cart.currency,
            value: (cart.total_price || 0) / 100,
            items: (cart.items || []).map(function (item) {
              return {
                item_id: item.variant_id,
                item_name: item.product_title,
                item_variant: item.variant_title,
                item_brand: item.vendor,
                price: item.price / 100,
                quantity: item.quantity,
              };
            }),
          },
        });
      })
      .catch(function () {});
  });
})();
